import { cn } from "@/lib/cn";
import type { Task } from "@/api/tasks";
import { useT } from "@/i18n";
import { framesTaskboardMessages } from "@/i18n/messages/frames-taskboard";
import { CalendarTaskPill } from "./calendar-task-pill";
import { localDateKey } from "./task-dates";

export function CalendarDayCell({
  date,
  tasks,
  isToday,
  isCurrentMonth,
  onSelectTask,
  onShowMore,
}: {
  date: Date;
  tasks: Task[];
  isToday: boolean;
  isCurrentMonth: boolean;
  onSelectTask: (taskId: string) => void;
  onShowMore: () => void;
}) {
  const t = useT(framesTaskboardMessages);
  const remaining = tasks.length - 3;
  return (
    <div
      className={cn(
        "flex min-h-24 min-w-0 flex-col rounded-control p-1",
        isToday
          ? "bg-[var(--color-interactive-hover)]"
          : "bg-[var(--color-surface-selected)]",
        !isCurrentMonth && "opacity-40",
      )}
      data-task-pocket-lane=""
      data-calendar-day={localDateKey(date)}
      data-testid={`calendar-cell-${localDateKey(date)}`}
    >
      <span
        className={cn(
          "mb-1 text-appkit-small",
          isToday ? "font-semibold text-primary" : "text-muted",
        )}
      >
        {date.getDate()}
      </span>
      <div className="flex flex-col gap-0.5">
        {tasks.slice(0, 3).map((task) => (
          <CalendarTaskPill key={task.id} task={task} onSelect={onSelectTask} />
        ))}
        {remaining > 0 && (
          <button
            type="button"
            className="nodrag truncate px-1 text-left text-appkit-small text-muted hover:text-primary"
            onClick={onShowMore}
            data-task-pocket-item={tasks
              .slice(3)
              .map((task) => task.id)
              .join(" ")}
            data-testid={`calendar-more-${localDateKey(date)}`}
          >
            {t("moreTasks", { count: remaining })}
          </button>
        )}
      </div>
    </div>
  );
}
